/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPasswordConfirm/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackToSignInAction from './BackToSignInAction/index'
import ConfirmAction from './ConfirmAction/index'
import Email from './Email/index'
import Info from 'DesignSystem/Info/index'
import Password from './Password/index'
import PasswordRules from './PasswordRules/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ResetPasswordConfirm({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="ResetPasswordConfirm.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-1qNAtJ': isBefore ? 0 : 1,'--tx-2-1qNAtJ': isBefore ? "-32px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResetPasswordConfirm.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-3-1qNAtJ': isMedia.mobile ? "340px" : "360px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="ResetPasswordConfirm.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-5-1qNAtJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--mb-4-1qNAtJ': isMedia.mobile ? typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL : "70px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Practice Hub"
 color={dtColorsGreen700}
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Set New Password"
/>
<div
  data-testid="ResetPasswordConfirm.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-6-1qNAtJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 marginRight={dtSpaceXxs}
 textOverflow="none"
 whiteSpace="wrap"
 text="For user"
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
</div>
<Password
  viewPath={`${viewPath}/Password`}
/>
<PasswordRules
  viewPath={`${viewPath}/PasswordRules`}
/>
<div
  data-testid="ResetPasswordConfirm.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-6-1qNAtJ': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal2}`}
>
<BackToSignInAction
  viewPath={`${viewPath}/BackToSignInAction`}
/>
<ConfirmAction
  viewPath={`${viewPath}/ConfirmAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}